import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hg7wwmygv: FaireProductEntity = {
  token: "p_3hg7wwmygv",
  type: "product",
  name: "Porcelain Trinket Dish | Oysters",
  brandToken: "b_11db373e",
  brandName: "Idlewild Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0f71b2a2998176a7f0aded591e3d0ecb8d1f46fbec37460ee4d163d95abf199b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0fdbfb7402d124ae501fa23130194d549be8b11c05091dafaa1cf4dc5b35f8fa.jpeg",
    "https://cdn.faire.com/fastly/2785a9cd2663c425ee0134fc5f5fc73ce5706d41d5e74820fa44986b7bcf3c7f.jpeg",
    "https://cdn.faire.com/fastly/71bcf694c962d58c2efcd7cd9090274b5cbea59d9d32eff86aa36f96090d3291.jpeg",
    "https://cdn.faire.com/fastly/8273792e1b87a04d97a8da26e22f706172307aeb5101be044f6a7846e8462c25.jpeg",
  ],
  priceDollars: 11,
  description:
    "A fan favorite giftable–Our ceramic trinket dishes are the perfect catchall for your nightstand or dresser. White porcelain is adorned with our colorful, hand-painted designs, and we lined the edge in 10k gold for added flair. Perfectly packaged in plastic-free gift boxes, pretty enough to give without wrapping!\n\n• Round Dish: 3.5″\n• Ceramic with 10k Gold Detailing\n• Plastic-Free Gift Box\n• Food-Safe | Hand Wash Only\n\n\n\n\nKeywords for SEO:\nTrinket Dish, Dish, Ring Dish, Ceramic, Porcelain, Gold, Idlewild Co., Idlewild, Accessory, Gift, Stocking Stuffer, Jewelry Dish, Jewelry Box, Nature, chef, foodie, kitchen, cook, oysters, shellfish, summer, home decor, vintage, display, earring display, displays for retail, gift idea, wedding, ceramics, engagement gift, jewelry displays, necklace display, ring dish, heart dish, heart trinket dish, trinket box, easter, mahjong, mahjong accessories, dice dish, dice dishes, summer gift, new england, new england gifts",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:25.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
